// extracted by mini-css-extract-plugin
module.exports = {"countDown":"CountDown_countDown__34dVk","times":"CountDown_times__1agx9","time":"CountDown_time__2QnqX"};